export const getIncludes = table => {
  const includes = []

  if (!table) {
    return ''
  }

  for (const fieldId of Object.keys(table.fields)) {
    const field = table.fields[fieldId]

    if (!field.type) {
      continue
    }

    if (field.type.type === 'belongsTo') {
      includes.push(`belongsTo~${fieldId}`)
    } else if (field.type.type === 'hasMany') {
      includes.push(`hasMany~${fieldId}`)
    } else if (field.type.type === 'manyToMany') {
      includes.push(`manyToMany~${fieldId}`)
    } else if (field.type.type === 'manyToManyReverse') {
      includes.push(`manyToMany~${fieldId}`)
    }
  }

  return includes.join(',')
}

export const getPrimaryField = table => {
  if (table.fields) {
    return Object.keys(table.fields).filter(key => {
      return table.fields[key].isPrimaryField
    })[0]
  }
}
